import { render, staticRenderFns } from "./view-traitement.html?vue&type=template&id=2dd756fe&scoped=true&external"
import script from "./view-traitement.js?vue&type=script&lang=js&external"
export * from "./view-traitement.js?vue&type=script&lang=js&external"
import style0 from "./view-traitement.scss?vue&type=style&index=0&id=2dd756fe&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd756fe",
  null
  
)

export default component.exports